import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


import Navbar from './Components/NavBar/Navbar';
import Home from './Pages/Home/Home';
import About from './Pages/About/About';
import Events from './Pages/Events/Events';
import Projects from './Pages/Projects/Projects';
import ProjectsDetails from './Pages/ProjectsDetails/ProjectsDetails';
import Training from './Pages/Training/Training';

import Research from './Pages/Research/Research';
import ResearchProjectDetails from './Pages/ResearchProjectDetails/ResearchProjectDetails';
import Collaboration from './Pages/Collaboration/Collaboration';
import Vacancies from './Pages/Vacancies/Vacancies';
import ContactUs from './Pages/ContactUs/ContactUs';
import Footer from './Components/Footer/Footer';
import EventDetails from './Components/Events/EventDetails';
import ImportantLinks from './Pages/ImportantLinks/ImportantLinks';
import KnowledgeRepository from './Pages/KnowledgeRepository/KnowledgeRepository';
import KnowledgeRepositoryDetails from './Pages/KnowledgeRepositoryDetails/KnowledgeRepositoryDetails';

import store from "./Redux/store";
import { Provider } from 'react-redux';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/about" element={<About />} />
          <Route path="/about/:id" element={<About />} />

          <Route path="/events" element={<Events />} />
          <Route path="/events/:id" element={<EventDetails />} />

          <Route path="/projects" element={<Projects />} />
          <Route path="/project/:id" element={<ProjectsDetails />} />

          <Route path="/training" element={<Training />} />
          <Route path="/training/:id" element={<Training />} />

          {/* <Route path="/research" element={<Research />} /> */}
          <Route path="/research/:id" element={<Research />} />
          <Route path="/research/:id/:id" element={<ResearchProjectDetails />} />

          <Route path="/collaboration" element={<Collaboration />} />
          <Route path="/collaboration/:id" element={<Collaboration />} />

          <Route path="/knowledgeRepository" element={<KnowledgeRepository />} />
          <Route path="/knowledgeRepository/:id" element={<KnowledgeRepositoryDetails />} />

          <Route path="/contact" element={<ContactUs />} />
          <Route path="/importantLinks" element={<ImportantLinks />} />
          <Route path="/vacancies" element={<Vacancies />} />

        </Routes>
        <Footer />
      </Router>
    </Provider>
  );
}

export default App;